import React from "react";
import BaseComponent from "../BaseComponent.js";
import moment from "moment";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { waitFor } from "../Global/tools.js";

import searchRequestService from "../../services/SearchService.js";
import playlistService from "../../services/PlaylistService.js";

import Type from "../Global/Typography.js";
import NanoFlex from "../Global/NanoFlex";
import Spinner from "../Nano/Spinner.js";
import Button from "../Nano/Buttons/Button.js";
import Dropdown from "../Nano/Dropdown.js";

import TreeNavigatorDropdown from "./../Nano/TreeNavigatorDropdown.js";
import MultipleSelectionDropdown from "./../Nano/MultipleSelectionDropdown.js";
import Calendar from "./../Micro/Calendar.js";
import Timeline from "./../Nano/Timeline.js";
import WeekSelect, { weekOptions } from "./../Nano/WeekSelect.js";
import PlatformSelect from "./../Nano/PlatformSelect.js";
import AudienceBoosterSelect from "./../Nano/AudienceBoosterSelect.js";
import NotaSelectionSelect from "./../Nano/NotaSelectionSelect.js";
import ProgrammesVideoSelect from "./../Nano/ProgrammesVideoSelect.js";
import KeywordSearchSelect from "./../Nano/KeywordSearchSelect.js";
import EvaluationSelect from "./../Nano/EvaluationSelect.js";

// IMAGES
import { ReactComponent as Plus } from "../Global/Icons/plus.svg";
import { ReactComponent as Less } from "../Global/Icons/minus.svg";
import { ReactComponent as Share } from "../Global/Icons/share.svg";
import { ReactComponent as Info } from "../Global/Icons/info.svg";

const multiple = nota.global.multiple;

const StyledAdvancedSearch = styled.div`
  display: ${(props) => (props.visible ? "block" : "none")};
  width: 300px;
  margin-left: ${nota.global.grid.navBar.width};

  .advancedSearchContainer {
    width: 300px;
    height: 100%;
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    margin-left: ${nota.global.grid.navBar.width};
    background: ${nota.color.neutral.white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding-top: 60px;
    .filtersWrapper {
      overflow: auto;
      .listWrapper {
        .inputWrapper {
          div {
            margin-bottom: ${multiple + "px"};
            input {
              width: ${multiple * 29 + "px"};
            }
          }
        }
        .comboWrapper {
          margin-bottom: ${multiple * 2 + "px"};
          width: ${multiple * 29 + "px"};
          p {
            margin-bottom: 2px;
          }
        }
      }
    }
  }

  .btnsWrapper {
    height: auto;
    min-height: -webkit-fit-content;

    .optionsWrapper {
      height: auto;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-color: ${nota.color.neutral.lightGrey};
      .moreFiltersWrapper {
        padding: ${multiple + "px"};
        cursor: pointer;
        .textWrapper {
          p {
            /* font-size: 12px; */
            color: ${(props) => (props.moreFiltersCollapsed ? nota.color.main.default : nota.color.main.mOne)};
            text-transform: uppercase;
            font-weight: bold;
          }
        }
        .iconWrapper {
          width: auto;

          .plusIcon {
            height: auto;
            width: 16px;
            path {
              fill: ${nota.color.main.default};
            }
          }
          .lessIcon {
            height: auto;
            width: 16px;
            path {
              fill: ${nota.color.main.mOne};
            }
          }
        }
      }

      &:hover {
        opacity: 0.7;
      }
    }

    .simpleBtnWrapper {
      border-top: 1px solid ${nota.color.neutral.NeuFour};
      div {
        width: 100%;
        text-align: center;
        .cta {
          padding: ${multiple + "px"};
          width: 100%;
          min-width: 100%;
          max-width: 100%;
          &:hover {
            color: ${nota.color.main.mTwo};
          }
        }
      }
    }
    .searchBtnsWrapper {
      background-color: ${nota.color.neutral.NeuOne};
      padding: ${multiple + "px"};
      min-height: -webkit-fit-content;
      .cta {
        width: ${multiple * 21 + "px"};
        margin: ${multiple / 2 + "px"};
      }
      .tertiaryCta {
        width: auto;
        .cta {
          border: none;
          color: ${nota.color.neutral.NeuOne};
        }
      }
    }
  }

  .quickFilters {
    height: auto;
    min-height: -webkit-fit-content;
  }

  .moreFilters {
    min-height: -webkit-fit-content;
    display: ${(props) => (props.moreFiltersCollapsed ? "none" : "flex")};
  }
  .advancedWrapper {
    position: relative;
  }
  .infoWrapper {
    margin-top: 4px;
    padding: 4px;
    background-color: ${nota.color.main.mOne};
    h6 {
      color: ${nota.color.neutral.white};
      text-transform: uppercase;
    }
  }

  .infoLabel {
    position: absolute;
    top: -11px;
    right: 12px;
    width: 20px;
    background-color: ${nota.color.neutral.white};
    height: 17px;
    border-radius: 0 0 16px 16px;
    cursor: pointer;
    z-index: 2;
    box-shadow: 0px 2px 2px rgb(0 0 0 / 25%);
    .infoIcon {
      height: auto;
      width: 14px;
    }
  }
  .iconDropDown {
    width: auto;
    svg {
      path {
        fill: ${nota.color.main.mOne};
      }
    }
  }

  .dropdown-content {
    left: unset;
    transform: translate(0%);
    right: -20px;
    top: 13px;
    margin: 16px;
  }
  .tooltipWrapper {
    min-width: 250px;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: ${multiple + "px"}; /* 8px */
    position: relative;
    cursor: default;
    &:after,
    &:before {
      bottom: 100%;
      right: 5px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: ${nota.color.neutral.white};
      border-width: 8px;
      margin-right: 0px;
    }
    &:before {
      border-color: rgba(0, 168, 225, 0);
      border-bottom-color: ${nota.color.neutral.NeuTwo};
      border-width: 9px;
      margin-right: -1px;
    }
    .optionLine {
      padding: ${multiple + "px"}; /* 8px */
      border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
      .performanceWrapper {
        margin-right: ${multiple * 2 + "px"}; /*16px */
      }
      p {
        letter-spacing: 1px;
        font-size: 12px;
        width: 100%;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    width: 100%;
    margin-left: 0;
    .advancedSearchContainer {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 42px);

      .searchBtnsWrapper {
        flex-direction: row;
        .cta {
          width: 100%;
        }
        .buttonWrapper {
          margin-left: 16px;
        }
      }
    }
  }
`;

class AdvancedSearch extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();

    /*Selected*/
    this.selected = this.getDefaultSelection();
    /*Requests Stack */
    this.requests = {
      broadcast: 1,
      producedIn: 1,
      developedIn: 1,
      genre: 1,
      platform: 1,
      keywords: 1,
      // beginEndDate: 1,
    };

    this._loadingAllData = false;
  }

  getDefaultState = () => {
    return {
      moreFiltersCollapsed: true,

      broadcasts: null,
      genres: null,
      formatTypes: null,
      timeslots: null,

      producedIn: null,
      developedIn: null,
      keywords: null,
      platforms: null,
      frequencies: null,
      durations: null,

      // minDate: null,
      // maxDate: null,

      playlists: null,

      forceSelection: false,
    };
  };

  getDefaultSelection = () => {
    return {
      searchFrom: "QuickSearch",
      //Broadcasts
      allBroadcastsSelected: false,
      selectedBroadcasts: [],
      //ProducedIn
      allProducedInSelected: false,
      selectedProducedIn: [],
      //DevelopedIn
      allDevelopedInSelected: false,
      selectedDevelopedIn: [],
      //Genres
      allGenresSelected: false,
      selectedGenres: [],
      //FormatTypes
      allFormatTypesSelected: false,
      selectedFormatTypes: [],
      //Timeslots
      allTimeslotsSelected: false,
      selectedTimeslots: [],
      //Date Range
      startDate: null, //moment(new Date()).add(-1, "years").format(nota.global.moment.serverDate),
      endDate: null, //moment(new Date()).format(nota.global.moment.serverDate),
      //Keywords
      searchByAllKeywords: false,
      allKeywordsSelected: false,
      selectedKeywords: [],
      //Frequencies
      allFrequenciesSelected: false,
      selectedFrequencies: [],
      //Platforms
      allPlatformsSelected: false,
      selectedPlatforms: [],
      //Weekdays
      allWeekdaysSelected: false,
      selectedWeekdays: [],
      //Nota Selection
      isNotaSelection: false,
      //Video
      isVideoPresent: false,
      //MarketShareComparison
      selectedMarketShareComparison: null,
      //Duration
      selectedDurations: null,
      //Playlists
      allPlaylistsSelected: false,
      selectedPlaylists: [],
      //Evaluation
      hasEvaluation: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onAdvancedSearchLanguageChange, false);
    window.addEventListener("submitSearch", this.onSubmitSearch, false);
    window.addEventListener("clearSearch", this.onClearSearch, false);
    window.addEventListener("setSearchFrom", this.setSearchFrom, false);
    window.addEventListener("playlistsChange", this.onPlaylistsListChange, false);
    window.addEventListener("deleteFilter", this.onDeleteFilter, false);
    window.addEventListener("getRecapFilters", this.onGetRecapFilters, false);

    if (this.props.visible) {
      this.getAllComponentsData();
    }

    this.triggerOnAdvancedSearchChange();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== this.props.visible) {
      if (this.props.visible && this.isComponentDataLoaded() == false) {
        this.getAllComponentsData();
      }
    }

    if (this.state.forceSelection) {
      this.setState({ forceSelection: false });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onAdvancedSearchLanguageChange, false);
    window.removeEventListener("submitSearch", this.onSubmitSearch, false);
    window.removeEventListener("clearSearch", this.onClearSearch, false);
    window.removeEventListener("setSearchFrom", this.setSearchFrom, false);
    window.removeEventListener("playlistsChange", this.onPlaylistsListChange, false);
    window.removeEventListener("deleteFilter", this.onDeleteFilter, false);
    window.removeEventListener("getRecapFilters", this.onGetRecapFilters, false);
  }

  onSubmitSearch = () => {
    if (this.props.visible) {
      this.searchClick();
    } else {
      this.triggerOnAdvancedSearchChange();
    }
  };

  setSearchFrom = (e) => {
    if (e.detail.menu !== "SavedSearch" && e.detail.menu !== "SearchFromCard") {
      /*Clear Header Filters*/
      window.dispatchEvent(new Event("clearHeader"));
    }
    switch (
      e.detail.menu //eslint-disable-line
    ) {
      case "NotaSelection":
        var selection = this.getDefaultSelection();
        selection.searchFrom = "NotaSelection";
        selection.isNotaSelection = true;
        selection.endDate = null;
        selection.startDate = null;
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "Latest":
        var selection = this.getDefaultSelection();
        selection.searchFrom = "Latest";
        selection.endDate = moment().add(-1, "days").format(nota.global.moment.serverDate);
        selection.startDate = moment(selection.endDate, nota.global.moment.serverDate).add(-1, "years").format(nota.global.moment.serverDate);
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "Upcoming":
        var selection = this.getDefaultSelection();
        selection.searchFrom = "Upcoming";
        selection.endDate = null;
        selection.startDate = moment().format(nota.global.moment.serverDate);
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "AudienceBooster":
        var selection = this.getDefaultSelection();
        selection.searchFrom = "AudienceBooster";
        selection.selectedMarketShareComparison = "BiggerOrEqual";
        selection.endDate = moment().format(nota.global.moment.serverDate);
        selection.startDate = moment(selection.endDate, nota.global.moment.serverDate).add(-1, "years").format(nota.global.moment.serverDate);
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "SavedSearch":
        var selection = e.detail.filter ? e.detail.filter : this.getDefaultSelection();
        selection.searchFrom = "SavedSearch";
        selection.savedSearchId = e.detail.id;
        selection.lastCall = e.detail.lastCall;
        selection.refreshLastCall = true;
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "Playlist":
        var selection = this.getDefaultSelection();
        selection.searchFrom = "Playlist";
        selection.selectedPlaylists = [e.detail.id];
        selection.endDate = null;
        selection.startDate = null;
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          this.triggerOnAdvancedSearchChange();
        });
        break;
      case "SearchFromCard":
        var selection = e.detail.filter ? { ...this.getDefaultSelection(), ...e.detail.filter } : this.getDefaultSelection();
        selection.searchFrom = "AdvancedSearch";
        this.selected = selection;
        this.setState({ forceSelection: true }, () => {
          /*Validate if selectedCountries or selectedGenresGroups have values */
          if (selection.selectedCountries || selection.selectedGenresGroups) {
            /*Continue func to prevent duplicated rules after validating if Component Data is Loaded */
            let continueSearchFromCardRules = () => {
              if (selection.selectedCountries) {
                this.selected.selectedBroadcasts = this.state.broadcasts
                  .filter((b) => selection.selectedCountries.includes(b.id))
                  .map((b) => b.channels.map((c) => c.id))
                  .flat();
              }
              if (selection.selectedGenresGroups) {
                this.selected.selectedGenres = this.state.genres
                  .filter((g) => selection.selectedGenresGroups.includes(g.id))
                  .map((g) => g.subGenres.map((sg) => sg.id))
                  .flat();
              }

              this.triggerOnAdvancedSearchChange();
            };

            /*Load data else continue to search card rules */
            if (this.isComponentDataLoaded() == false) {
              //Set Card Loading true
              window.dispatchEvent(new CustomEvent("setCardLoading", { detail: true }));
              this.getAllComponentsData();
              waitFor((l) => this.isComponentDataLoaded()).then(() => {
                continueSearchFromCardRules();
                //Set Card Loading false
                window.dispatchEvent(new CustomEvent("setCardLoading", { detail: false }));
              });
            } else {
              continueSearchFromCardRules();
            }
          } else {
            this.triggerOnAdvancedSearchChange();
          }
        });
        break;
    }
  };
  onPlaylistsListChange = () => {
    /*Reload Playlists Select on Change*/
    this.getPlaylists();
  };

  onAdvancedSearchLanguageChange = () => {
    let defaultState = this.getDefaultState();
    //Keep current open/close state
    defaultState.moreFiltersCollapsed = this.state.moreFiltersCollapsed;
    this.setState(defaultState, () => {
      this.getAllComponentsData();
    });
  };

  onDeleteFilter = (e) => {
    if (!e.detail) return;

    let prevSelected = JSON.stringify(this.selected);
    e.detail.forEach((f) => {
      switch (f.field) {
        case "StartDate":
          this.selected.startDate = null;
          break;
        case "EndDate":
          this.selected.endDate = null;
          break;
        case "Broadcasts":
          this.selected.allBroadcastsSelected = false;
          this.selected.selectedBroadcasts = [];
          break;
        case "ProducedIn":
          this.selected.allProducedInSelected = false;
          this.selected.selectedProducedIn = [];
          break;
        case "DevelopedIn":
          this.selected.allDevelopedInSelected = false;
          this.selected.selectedDevelopedIn = [];
          break;
        case "Genres":
          this.selected.allGenresSelected = false;
          this.selected.selectedGenres = [];
          break;
        case "FormatTypes":
          this.selected.allFormatTypesSelected = false;
          this.selected.selectedFormatTypes = [];
          break;
        case "Playlists":
          this.selected.allPlaylistsSelected = false;
          this.selected.selectedPlaylists = [];
          break;
        case "Platforms":
          this.selected.allPlatformsSelected = false;
          this.selected.selectedPlatforms = [];
          break;
        case "Keywords":
          this.selected.searchByAllKeywords = false;
          this.selected.allKeywordsSelected = false;
          this.selected.selectedKeywords = [];
          break;
        case "Frequencies":
          this.selected.allFrequenciesSelected = false;
          this.selected.selectedFrequencies = [];
          break;
        case "Weekdays":
          this.selected.allWeekdaysSelected = false;
          this.selected.selectedWeekdays = [];
          break;
        case "Timeslots":
          this.selected.allTimeslotsSelected = false;
          this.selected.selectedTimeslots = [];
          break;
        case "Duration":
          this.selected.selectedDurations = null;
          break;
        case "NotaSelection":
          this.selected.isNotaSelection = false;
          break;
        case "VideoPresent":
          this.selected.isVideoPresent = false;
          break;
        case "MarketShareComparison":
          this.selected.selectedMarketShareComparison = null;
          break;
        case "Evaluation":
          this.selected.hasEvaluation = false;
          break;
      }
    });
    if (prevSelected !== JSON.stringify(this.selected)) {
      /*Close Advanced Search*/
      window.dispatchEvent(new Event("closeAdvancedSearch"));
      this.searchClick();
    }
  };

  onGetRecapFilters = async (e) => {
    if (e?.detail?.callback) {
      if (this.isComponentDataLoaded() == false) {
        this.getAllComponentsData();
        await waitFor((l) => this.isComponentDataLoaded());
      }

      e.detail.callback(this.getRecapFilters(e));
    }
  };

  moreFiltersClick = () => {
    this.setState({ moreFiltersCollapsed: !this.state.moreFiltersCollapsed }, () => {
      if (this.state.moreFiltersCollapsed) {
        document.querySelector(".quickFilters").scrollIntoView();
      } else {
        document.querySelector(".moreFilters").scrollIntoView();
      }
    });
  };

  saveClick = () => {
    if (this.props.onAdvancedSearchSave) {
      this.props.onAdvancedSearchSave(this.getSelectedWithDefault());
    }
  };

  searchClick = () => {
    this.selected.searchFrom = "AdvancedSearch";
    this.triggerOnAdvancedSearchChange();
  };

  triggerOnAdvancedSearchChange = () => {
    if (this.props.onAdvancedSearchChange) {
      this.props.onAdvancedSearchChange(this.getSelectedWithDefault());
    }
  };

  getSelectedWithDefault = () => {
    let defaultSelection = this.getDefaultSelection();
    return {
      ...this.selected,
      ...{
        isDefault: JSON.stringify({ ...this.selected, ...{ searchFrom: defaultSelection.searchFrom } }) === JSON.stringify({ ...defaultSelection, ...{ startDate: null, endDate: null } }),
      },
    };
  };

  /*Get Component Data */
  getAllComponentsData = () => {
    if (this._loadingAllData === false) {
      this._loadingAllData = true;
      //this.getMinMaxDate();
      this.getBroadcasts();
      this.getGenres();
      this.getFormatTypes();
      this.getTimeslots();

      this.getKeywords();
      this.getProducedIn();
      this.getDevelopedIn();
      this.getPlatforms();
      this.getFrequencies();
      this.getDurations();
      this.getPlaylists();

      waitFor((l) => this.isComponentDataLoaded()).then(() => (this._loadingAllData = false));
    }
  };

  isComponentDataLoaded = () => {
    /*Validate null on state variables that get data from async services */
    if (this.state.keywords == null || this.state.broadcasts == null || this.state.producedIn == null || this.state.developedIn == null || this.state.genres == null || this.state.frequencies == null || this.state.platforms == null || this.state.playlists == null) {
      return false;
    } else {
      return true;
    }
  };

  getFormatTypes = () => {
    this.setState({
      formatTypes: [
        {
          id: 1,
          name: this.translation.advancedSearch.formatTypes.original,
        },
        {
          id: 3,
          name: this.translation.advancedSearch.formatTypes.adaptation,
        },
        {
          id: 2,
          name: this.translation.advancedSearch.formatTypes.acquired,
        },
      ],
    });
  };

  getTimeslots = () => {
    this.setState({
      timeslots: [
        {
          id: "daytime",
          name: this.translation.advancedSearch.timeslots.daytime,
        },
        {
          id: "access_primetime",
          name: this.translation.advancedSearch.timeslots.accessPrimetime,
        },
        {
          id: "primetime",
          name: this.translation.advancedSearch.timeslots.primetime,
        },
        {
          id: "latenight",
          name: this.translation.advancedSearch.timeslots.lateNight,
        },
      ],
    });
  };

  getDurations = () => {
    this.setState({
      durations: [
        {
          start: null,
          end: 9,
          name: "< 10",
        },
        {
          start: 10,
          end: 30,
          name: "10 - 30",
        },
        {
          start: 31,
          end: 60,
          name: "31 - 60",
        },
        {
          start: 61,
          end: null,
          name: "> 60",
        },
      ],
    });
  };

  getKeywords = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.searchByAllKeywords = false;
    immutableSelected.allKeywordsSelected = false;
    immutableSelected.selectedKeywords = [];

    searchRequestService
      .getKeywords(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ keywords: data });
      });
  };

  // getMinMaxDate = () => {
  //   let immutableSelected = JSON.parse(JSON.stringify(this.selected));
  //   /*Prevent Self Filter */
  //   immutableSelected.startDate = null;
  //   immutableSelected.endDate = null;

  //   searchRequestService
  //     .getMinMaxDatesbyPrograms(immutableSelected)
  //     .then((response) => {
  //       if (response.ok) {
  //         return response.json();
  //       } else {
  //         // Catch
  //         if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
  //       }
  //     })
  //     .then((data) => {
  //       this.setState({ minDate: data ? moment(data.minDate).toDate() : null, maxDate: data ? moment(data.maxDate).toDate() : null });
  //     });
  // };

  getBroadcasts = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.allBroadcastsSelected = false;
    immutableSelected.selectedBroadcasts = [];

    searchRequestService
      .getCountriesByPrograms(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ broadcasts: data });
      });
  };

  getProducedIn = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.allProducedInSelected = false;
    immutableSelected.selectedProducedIn = [];

    searchRequestService
      .getCountriesProducedIn(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ producedIn: data });
      });
  };

  getDevelopedIn = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.allDevelopedInSelected = false;
    immutableSelected.selectedDevelopedIn = [];

    searchRequestService
      .getCountriesDevelopedIn(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ developedIn: data });
      });
  };

  getGenres = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.allGenresSelected = false;
    immutableSelected.selectedGenres = [];

    searchRequestService
      .getGenres(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ genres: data });
      });
  };

  getPlatforms = () => {
    let immutableSelected = JSON.parse(JSON.stringify(this.selected));
    /*Prevent Self Filter */
    immutableSelected.allPlatformsSelected = false;
    immutableSelected.selectedPlatforms = [];

    searchRequestService
      .getPlatforms(immutableSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ platforms: data });
      });
  };

  getFrequencies = () => {
    searchRequestService
      .getFrequencies(this.selected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ frequencies: [...[{ id: -1, name: this.translation.advancedSearch.frequenciesNoFrequency }], ...data] });
      });
  };

  getPlaylists = () => {
    playlistService
      .getPlaylists(true)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlists: data });
      });
  };

  getRecapFilters = (e) => {
    let recap = [];

    if (!e.detail?.excludeHeaderRecap) {
      /*Add Header Recap Filters*/
      let headerRecap = sessionStorage.getItem("headerRecapFilters") ? JSON.parse(sessionStorage.getItem("headerRecapFilters")) : [];
      if (headerRecap.length > 0) {
        recap = headerRecap;
      }
    }

    if (this.selected.searchFrom !== "QuickSearch") {
      //Start End Date
      if (this.selected.startDate)
        recap.push({
          translation: "advancedSearch.startDateTitle",
          field: "StartDate",
          values: [
            {
              name: moment(this.selected.startDate, nota.global.moment.serverDate)
                .locale(this.getMomentLanguage())
                .format(this.getMomentLanguage ? nota.global.moment.displayDate.en : nota.global.moment.displayDate.ch),
            },
          ],
        });
      if (this.selected.endDate)
        recap.push({
          translation: "advancedSearch.endDateTitle",
          field: "EndDate",
          values: [
            {
              name: moment(this.selected.endDate, nota.global.moment.serverDate)
                .locale(this.getMomentLanguage())
                .format(this.getMomentLanguage ? nota.global.moment.displayDate.en : nota.global.moment.displayDate.ch),
            },
          ],
        });
    }

    //Broadcast in
    if (this.state.broadcasts && this.selected.selectedBroadcasts !== null) {
      recap.push({
        translation: "advancedSearch.broadcastsTitle",
        field: "Broadcasts",
        values: this.buildBroadcastsTreeView(
          this.selected.allBroadcastsSelected
            ? this.state.broadcasts
            : JSON.parse(JSON.stringify(this.state.broadcasts)).filter((b) => {
                b.channels = b.channels.filter((c) => this.selected.selectedBroadcasts.includes(c.id));
                return b.channels.length > 0;
              })
        ),
        isAllSelected: this.selected.allBroadcastsSelected,
      });
    }

    //Produced In
    if (this.state.producedIn && this.selected.selectedProducedIn !== null) {
      recap.push({
        translation: "advancedSearch.producedInTitle",
        field: "ProducedIn",
        values: this.selected.allProducedInSelected ? this.state.producedIn : this.state.producedIn.filter((b) => this.selected.selectedProducedIn.includes(b.id)),
        isAllSelected: this.selected.allProducedInSelected,
      });
    }

    //Developed in
    if (this.state.developedIn && this.selected.selectedDevelopedIn !== null) {
      recap.push({
        translation: "advancedSearch.developedInTitle",
        field: "DevelopedIn",
        values: this.selected.allDevelopedInSelected ? this.state.developedIn : this.state.developedIn.filter((b) => this.selected.selectedDevelopedIn.includes(b.id)),
        isAllSelected: this.selected.allDevelopedInSelected,
      });
    }

    //Genres
    if (this.state.genres && this.selected.selectedGenres !== null) {
      recap.push({
        translation: "advancedSearch.genresTitle",
        field: "Genres",
        values: this.buildGenresTreeView(
          this.selected.allGenresSelected
            ? this.state.genres
            : JSON.parse(JSON.stringify(this.state.genres)).filter((b) => {
                b.subGenres = b.subGenres.filter((c) => this.selected.selectedGenres.includes(c.id));
                return b.subGenres.length > 0;
              })
        ),
        isAllSelected: this.selected.allGenresSelected,
      });
    }

    //Format Types
    if (this.state.formatTypes && this.selected.selectedFormatTypes !== null) {
      recap.push({
        translation: "advancedSearch.formatTypesTitle",
        field: "FormatTypes",
        values: this.selected.allFormatTypesSelected ? this.state.formatTypes : this.state.formatTypes.filter((b) => this.selected.selectedFormatTypes.includes(b.id)),
        isAllSelected: this.selected.allFormatTypesSelected,
      });
    }

    //Timeslots
    if (this.state.timeslots && this.selected.selectedTimeslots !== null) {
      recap.push({
        translation: "advancedSearch.timeslotsTitle",
        field: "Timeslots",
        values: this.selected.allTimeslotsSelected ? this.state.timeslots : this.state.timeslots.filter((b) => this.selected.selectedTimeslots.includes(b.id)),
        isAllSelected: this.selected.allTimeslotsSelected,
      });
    }

    //Playlists
    if (this.state.playlists && this.selected.selectedPlaylists !== null) {
      recap.push({
        translation: "advancedSearch.playlistsTitle",
        field: "Playlists",
        values: this.selected.allPlaylistsSelected ? this.state.playlists : this.state.playlists.filter((b) => this.selected.selectedPlaylists.includes(b.id)),
        isAllSelected: this.selected.allPlaylistsSelected,
      });
    }

    //Platforms
    if (this.state.platforms && this.selected.selectedPlatforms !== null) {
      recap.push({
        translation: "advancedSearch.platformsTitle",
        field: "Platforms",
        values: (this.selected.allPlatformsSelected ? this.state.platforms : this.state.platforms.filter((b) => this.selected.selectedPlatforms.includes(b))).map((b) => {
          return {
            id: b,
            name: b === 1 ? "TV" : b === 2 ? "ONLINE" : null,
          };
        }),
        isAllSelected: this.selected.allPlatformsSelected,
      });
    }

    //Keywords
    if (this.state.keywords && this.selected.selectedKeywords !== null) {
      recap.push({
        translation: "advancedSearch.keywords.title",
        field: "Keywords",
        values: this.selected.allKeywordsSelected
          ? this.state.keywords
          : JSON.parse(JSON.stringify(this.state.keywords)).filter((b) => {
              b.childs = b.childs.filter((c) => this.selected.selectedKeywords.includes(c.id));
              return b.childs.length > 0;
            }),
        isAllSelected: this.selected.allKeywordsSelected,
      });
    }

    //Frequencies
    if (this.state.frequencies && this.selected.selectedFrequencies !== null) {
      recap.push({
        translation: "advancedSearch.frequenciesTitle",
        field: "Frequencies",
        values: this.selected.allFrequenciesSelected ? this.state.frequencies : this.state.frequencies.filter((b) => this.selected.selectedFrequencies.includes(b.id)),
        isAllSelected: this.selected.allFrequenciesSelected,
      });
    }

    //Weekdays
    if (weekOptions && this.selected.selectedWeekdays !== null) {
      recap.push({
        translation: "advancedSearch.weekdaysTitle",
        field: "Weekdays",
        values: (this.selected.allWeekdaysSelected ? weekOptions : weekOptions.filter((b) => this.selected.selectedWeekdays.includes(b.id))).map((b) => {
          return {
            id: b.id,
            name: this.translation.components.weekSelect[b.name],
          };
        }),
        isAllSelected: this.selected.allWeekdaysSelected,
      });
    }

    //Duration
    if (this.selected.selectedDurations && this.state.durations) {
      recap.push({
        translation: "advancedSearch.durationTitle",
        field: "Duration",
        values: this.state.durations.filter((b) => this.selected.selectedDurations.includes(b)),
      });
    }

    //NotaSelection
    if (this.selected.isNotaSelection) recap.push({ translation: "advancedSearch.notaSelection.title", field: "NotaSelection", values: [{ name: this.translation.advancedSearch.selected }] });

    //Video
    if (this.selected.isVideoPresent) recap.push({ translation: "advancedSearch.programmesVideo.title", field: "VideoPresent", values: [{ name: this.translation.advancedSearch.selected }] });

    //Audience boosters
    if (this.selected.selectedMarketShareComparison === "BiggerOrEqual") recap.push({ translation: "advancedSearch.audienceBoosters.title", field: "MarketShareComparison", values: [{ name: this.translation.advancedSearch.selected }] });

    //Evaluation
    if (this.selected.hasEvaluation) recap.push({ translation: "advancedSearch.evaluation.title", field: "Evaluation", values: [{ name: this.translation.advancedSearch.selected }] });

    return recap.filter((r) => r.values.length > 0);
  };

  /*Build Component Data */
  buildNameSelect = (arr) => {
    return arr.map((c) => {
      return c.name;
    });
  };

  buildBroadcastsTreeView = (countries) => {
    if (countries != null) {
      return countries.map((v) => {
        return {
          id: v.id,
          name: v.name,
          childs: v.channels.map((ch) => {
            return {
              id: ch.id,
              name: ch.name,
            };
          }),
        };
      });
    } else {
      return null;
    }
  };

  buildGenresTreeView = (genres) => {
    if (genres != null) {
      return genres.map((v) => {
        return {
          id: v.id,
          name: v.name,
          childs: v.subGenres.map((ch) => {
            return {
              id: ch.id,
              name: ch.name,
            };
          }),
        };
      });
    } else {
      return null;
    }
  };

  /*Change Events*/
  onBroadcastsChange = (e) => {
    this.selected.allBroadcastsSelected = e.isAllSelected;
    this.selected.selectedBroadcasts = e.selected.map(Number);

    this.requests.broadcast++;
    var requestId = this.requests.broadcast;
    setTimeout(() => {
      if (requestId === this.requests.broadcast) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getProducedIn();
        this.getDevelopedIn();
        this.getGenres();
        this.getKeywords();
        this.getPlatforms();
      }
    }, 500);
  };

  onGenresChange = (e) => {
    this.selected.allGenresSelected = e.isAllSelected;
    this.selected.selectedGenres = e.selected.map(Number);

    this.requests.genre++;
    var requestId = this.requests.genre;
    setTimeout(() => {
      if (requestId === this.requests.genre) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getBroadcasts();
        this.getProducedIn();
        this.getDevelopedIn();
        this.getKeywords();
        this.getPlatforms();
      }
    }, 500);
  };

  onFormatTypesChange = (e) => {
    this.selected.allFormatTypesSelected = e.isAllSelected;
    this.selected.selectedFormatTypes = e.selected.map((v) => {
      return v.id;
    });
  };

  onTimeslotsChange = (e) => {
    this.selected.allTimeslotsSelected = e.isAllSelected;
    this.selected.selectedTimeslots = e.selected.map((v) => {
      return v.id;
    });
  };

  onBeginEndDateChange = (range) => {
    this.selected.startDate = range.startDate ? moment(range.startDate, nota.global.moment.serverDate).format(nota.global.moment.serverDate) : null;
    this.selected.endDate = range.endDate ? moment(range.endDate, nota.global.moment.serverDate).format(nota.global.moment.serverDate) : null;

    this.forceUpdate();

    // this.requests.beginEndDate++;
    // var requestId = this.requests.beginEndDate;
    // setTimeout(() => {
    //   if (requestId === this.requests.beginEndDate) {
    //     /*Load new filtered data */
    //     this.getBroadcasts();
    //     this.getProducedIn();
    //     this.getDevelopedIn();
    //     this.getKeywords();
    //     this.getGenres();
    //     this.getPlatforms();
    //   }
    // }, 500);
  };

  onKeywordsChange = (e) => {
    this.selected.allKeywordsSelected = e.isAllSelected;
    this.selected.selectedKeywords = e.selected.map(Number);

    this.requests.keywords++;
    var requestId = this.requests.keywords;
    setTimeout(() => {
      if (requestId === this.requests.keywords) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getBroadcasts();
        this.getProducedIn();
        this.getDevelopedIn();
        this.getGenres();
        this.getPlatforms();
      }
    }, 500);
  };

  onKeywordSearchChange = (e) => {
    this.selected.searchByAllKeywords = e.selected;
  };

  onProducedInChange = (e) => {
    this.selected.allProducedInSelected = e.isAllSelected;
    this.selected.selectedProducedIn = e.selected.map((v) => {
      return v.id;
    });

    this.requests.producedIn++;
    var requestId = this.requests.producedIn;
    setTimeout(() => {
      if (requestId === this.requests.producedIn) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getBroadcasts();
        this.getDevelopedIn();
        this.getGenres();
        this.getKeywords();
        this.getPlatforms();
      }
    }, 500);
  };

  onDevelopedInChange = (e) => {
    this.selected.allDevelopedInSelected = e.isAllSelected;
    this.selected.selectedDevelopedIn = e.selected.map((v) => {
      return v.id;
    });

    this.requests.developedIn++;
    var requestId = this.requests.developedIn;
    setTimeout(() => {
      if (requestId === this.requests.developedIn) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getBroadcasts();
        this.getProducedIn();
        this.getGenres();
        this.getKeywords();
        this.getPlatforms();
      }
    }, 500);
  };

  onFrequenciesChange = (e) => {
    this.selected.allFrequenciesSelected = e.isAllSelected;
    this.selected.selectedFrequencies = e.selected.map((v) => {
      return v.id;
    });
  };

  onPlatformsChange = (e) => {
    this.selected.allPlatformsSelected = e.isAllSelected;
    this.selected.selectedPlatforms = [...e.selectedIds];

    this.requests.platform++;
    var requestId = this.requests.platform;
    setTimeout(() => {
      if (requestId === this.requests.platform) {
        /*Load new filtered data */
        //this.getMinMaxDate();
        this.getBroadcasts();
        this.getProducedIn();
        this.getDevelopedIn();
        this.getGenres();
        this.getKeywords();
      }
    }, 500);
  };

  onWeekdaysChange = (e) => {
    this.selected.allWeekdaysSelected = e.isAllSelected;
    this.selected.selectedWeekdays = [...e.selectedIds];
  };

  onNotaSelectionChange = (e) => {
    this.selected.isNotaSelection = e.selected;
  };

  onMarketShareComparisonChange = (e) => {
    this.selected.selectedMarketShareComparison = e.selected;
  };

  onIsVideoPresentChange = (e) => {
    this.selected.isVideoPresent = e.selected;
  };

  onHasEvaluationChange = (e) => {
    this.selected.hasEvaluation = e.selected;
  };

  onDurationChange = (e) => {
    this.selected.selectedDurations = this.state.durations.filter((v) => {
      return e.selectedDurations.includes(v.name);
    });
  };

  onPlaylistsChange = (e) => {
    this.selected.allPlaylistsSelected = e.isAllSelected;
    this.selected.selectedPlaylists = e.selected.map((v) => {
      return v.id;
    });
  };

  onClearSearch = (e) => {
    let newSelection = this.getDefaultSelection();
    if (e.detail?.searchFrom) {
      newSelection.searchFrom = e.detail?.searchFrom;
    }
    /*Validate if something changed from default*/
    if (JSON.stringify(this.selected) !== JSON.stringify(newSelection)) {
      /*Selected*/
      this.selected = newSelection;
      this.setState({ forceSelection: true }, () => {
        /*Get new filtered data */
        this.getAllComponentsData();

        this.triggerOnAdvancedSearchChange();
      });
    } else {
      this.setState({ forceSelection: true });
    }
  };

  onClearClick = () => {
    window.dispatchEvent(new Event("clearSearch"));
  };

  render() {
    const { broadcasts, genres, formatTypes, timeslots, producedIn, developedIn, keywords, frequencies, platforms, durations, playlists, forceSelection } = this.state;

    return (
      <StyledAdvancedSearch className={"advancedSearchMenu"} visible={this.props.visible} moreFiltersCollapsed={this.state.moreFiltersCollapsed}>
        <NanoFlex className="advancedSearchContainer" flexDirection="column">
          {!this.isComponentDataLoaded() && <Spinner />}
          {this.isComponentDataLoaded() && (
            <NanoFlex className="advancedWrapper" flexDirection="column">
              <NanoFlex className="infoLabel">
                <Dropdown
                  enableHover
                  onClickOutsideClose
                  main={<Info className="infoIcon" />}
                  content={
                    <NanoFlex>
                      <NanoFlex className="tooltipWrapper" flexDirection={"column"}>
                        <NanoFlex className="optionLine">
                          <Type.p>{this.translation.advancedSearch.info}</Type.p>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  }
                />
              </NanoFlex>
              <NanoFlex className="filtersWrapper" flexDirection="column" justifyContent="unset">
                <NanoFlex className="listWrapper quickFilters" flexDirection="column" justifyContent="flex-start">
                  <div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.broadcastsTitle}</Type.p>
                      <TreeNavigatorDropdown options={this.buildBroadcastsTreeView(broadcasts)} onChangeSelection={this.onBroadcastsChange} selected={this.selected.selectedBroadcasts} isAllSelected={this.selected.allBroadcastsSelected} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.producedInTitle}</Type.p>
                      <MultipleSelectionDropdown options={producedIn} onChangeSelection={this.onProducedInChange} selected={this.selected.selectedProducedIn} isAllSelected={this.selected.allProducedInSelected} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.developedInTitle}</Type.p>
                      <MultipleSelectionDropdown options={developedIn} onChangeSelection={this.onDevelopedInChange} selected={this.selected.selectedDevelopedIn} isAllSelected={this.selected.allDevelopedInSelected} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.genresTitle}</Type.p>
                      <TreeNavigatorDropdown options={this.buildGenresTreeView(genres)} onChangeSelection={this.onGenresChange} selected={this.selected.selectedGenres} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.formatTypesTitle}</Type.p>
                      <MultipleSelectionDropdown options={formatTypes} onChangeSelection={this.onFormatTypesChange} selected={this.selected.selectedFormatTypes} isAllSelected={this.selected.allFormatTypesSelected} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.timeslotsTitle}</Type.p>
                      <MultipleSelectionDropdown options={timeslots} onChangeSelection={this.onTimeslotsChange} selected={this.selected.selectedTimeslots} isAllSelected={this.selected.allTimeslotsSelected} forceSelection={forceSelection} />
                    </div>
                    <div className="comboWrapper">
                      <Type.p>{this.translation.advancedSearch.startEndDateTitle}</Type.p>
                      <Calendar
                        inputDate={{
                          startDate: moment(this.selected.startDate, nota.global.moment.serverDate).format(nota.global.moment.serverDate),
                          endDate: moment(this.selected.endDate, nota.global.moment.serverDate).format(nota.global.moment.serverDate),
                        }}
                        // minDate={this.state.minDate}
                        // maxDate={this.state.maxDate}
                        onChangeSelection={this.onBeginEndDateChange}
                        forceSelection={forceSelection}
                        isOpenDropdownChanged={(isOpenDropdown) => {
                          if (isOpenDropdown && this.selected.startDate === null && this.selected.endDate === null) {
                            this.selected.startDate = moment(new Date()).add(-1, "years").format(nota.global.moment.serverDate);
                            this.selected.endDate = moment(new Date()).format(nota.global.moment.serverDate);
                            this.forceUpdate();
                          }
                        }}
                      />
                      {(!this.selected.endDate || moment(this.selected.endDate, nota.global.moment.serverDate) > moment()) && (
                        <NanoFlex className="infoWrapper">
                          <Type.h6>{this.translation.advancedSearch.upcommingIncluded}</Type.h6>
                        </NanoFlex>
                      )}
                    </div>
                  </div>
                </NanoFlex>

                <NanoFlex className="listWrapper moreFilters" flexDirection="column" justifyContent="flex-start">
                  {!this.state.moreFiltersCollapsed && (
                    <div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.platformsTitle}</Type.p>
                        <PlatformSelect options={platforms} onChangeSelection={this.onPlatformsChange} selectedIds={this.selected.selectedPlatforms} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.keywords.title}</Type.p>
                        <TreeNavigatorDropdown options={keywords} onChangeSelection={this.onKeywordsChange} selected={this.selected.selectedKeywords} forceSelection={forceSelection} />
                        <KeywordSearchSelect onChangeSelection={this.onKeywordSearchChange} selected={this.selected.searchByAllKeywords} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.frequenciesTitle}</Type.p>
                        <MultipleSelectionDropdown options={frequencies} onChangeSelection={this.onFrequenciesChange} selected={this.selected.selectedFrequencies} isAllSelected={this.selected.allFrequenciesSelected} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.playlistsTitle}</Type.p>
                        <MultipleSelectionDropdown
                          options={playlists}
                          onChangeSelection={this.onPlaylistsChange}
                          selected={this.selected.selectedPlaylists}
                          isAllSelected={this.selected.allPlaylistsSelected}
                          forceSelection={forceSelection}
                          customContent={(item) => {
                            return (
                              <NanoFlex>
                                <Type.p>{item.name}</Type.p>
                                {item.isShared && (
                                  <NanoFlex className="iconDropDown" style={{ width: "20px" }}>
                                    <Share />
                                  </NanoFlex>
                                )}
                              </NanoFlex>
                            );
                          }}
                        />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.weekdaysTitle}</Type.p>
                        <WeekSelect selectedIds={this.selected.selectedWeekdays} isAllSelected={this.selected.allWeekdaysSelected} onChangeSelection={this.onWeekdaysChange} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.durationTitle}</Type.p>
                        <Timeline options={this.buildNameSelect(durations)} onChangeSelection={this.onDurationChange} selectedDurations={this.selected.selectedDurations != null ? this.selected.selectedDurations.map((d) => d.name) : null} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.notaSelection.title}</Type.p>
                        {/* <Type.h6>{this.translation.advancedSearch.notaSelection.subTitle}</Type.h6> */}
                        <NotaSelectionSelect selected={this.selected.isNotaSelection} onChangeSelection={this.onNotaSelectionChange} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.audienceBoosters.title}</Type.p>
                        {/* <Type.h6>{this.translation.advancedSearch.audienceBoosters.subTitle}</Type.h6> */}
                        <AudienceBoosterSelect onChangeSelection={this.onMarketShareComparisonChange} selected={this.selected.selectedMarketShareComparison} forceSelection={forceSelection} />
                      </div>
                      <div className="comboWrapper">
                        <Type.p>{this.translation.advancedSearch.programmesVideo.title}</Type.p>
                        {/* <Type.h6>{this.translation.advancedSearch.audienceBoosters.subTitle}</Type.h6> */}
                        <ProgrammesVideoSelect onChangeSelection={this.onIsVideoPresentChange} selected={this.selected.isVideoPresent} forceSelection={forceSelection} />
                      </div>
                      {!(window.env?.advancedSearch?.hideEvaluation ?? false) && (
                        <div className="comboWrapper">
                          <Type.p>{this.translation.advancedSearch.evaluation.title}</Type.p>
                          {/* <Type.h6>{this.translation.advancedSearch.audienceBoosters.subTitle}</Type.h6> */}
                          <EvaluationSelect onChangeSelection={this.onHasEvaluationChange} selected={this.selected.hasEvaluation} forceSelection={forceSelection} />
                        </div>
                      )}
                    </div>
                  )}
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="btnsWrapper" flexDirection="column">
                <NanoFlex className="optionsWrapper" flexDirection="column">
                  <NanoFlex className="moreFiltersWrapper" onClick={this.moreFiltersClick}>
                    <NanoFlex className="textWrapper" justifyContent="flex-start" alignItem="flex-start">
                      <Type.p>{this.state.moreFiltersCollapsed ? this.translation.advancedSearch.moreFilters : this.translation.advancedSearch.lessFilters}</Type.p>
                    </NanoFlex>

                    <NanoFlex className="iconWrapper" justifyContent="flex-end" alignItem="flex-end">
                      {this.state.moreFiltersCollapsed && <Plus className="plusIcon" />}
                      {!this.state.moreFiltersCollapsed && <Less className="lessIcon" />}
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
                <NanoFlex className="simpleBtnWrapper">
                  <Button label={this.translation.advancedSearch.clearAll} simple clickAction={(id) => this.onClearClick()} />
                </NanoFlex>
                <NanoFlex className="searchBtnsWrapper" flexDirection="column">
                  <NanoFlex className="tertiaryCta">
                    <Button label={this.translation.advancedSearch.saveSearch} secondary clickAction={() => this.saveClick()} />
                  </NanoFlex>
                  <Button label={this.translation.advancedSearch.search} clickAction={(id) => this.searchClick()} />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          )}
        </NanoFlex>
      </StyledAdvancedSearch>
    );
  }
}

// Set default props
AdvancedSearch.defaultProps = {
  visible: false,
};

export default AdvancedSearch;

// --- // Documentation // --- //
/*
import AdvancedSearch from './AdvancedSearch.js';

<AdvancedSearch />
*/
